// @ts-nocheck
import _isNil from 'lodash/isNil';
import _includes from 'lodash/includes';
import _reduce from 'lodash/reduce';
import _values from 'lodash/values';
import {
	EntityGroupActions,
	MiscellaneousEntityGroupActions,
	SettingsEntity,
	MiscellaneousEntity,
	PermissionLevel,
	MiscellaneousPermissionLevel,
	PERMISSION_LEVEL,
	MISCELLANEOUS_PERMISSION_LEVEL,
	CRMActions,
	EntityGroup,
	Entity,
	AppActions
} from 'constant';

interface getSettingsPermissionLevelProps {
	settingsPermissionConfig: PermissionLevel | EntityGroupActions;
	entity?: SettingsEntity;
}

interface getMiscellaneousPermissionLevelProps {
	miscellaneousPermissionConfig: MiscellaneousPermissionLevel | MiscellaneousEntityGroupActions;
	entity?: MiscellaneousEntity;
}

interface getCrmPermissionLevelProps {
	crmPermissionConfig: PermissionLevel | CRMActions;
	appName?: string;
	entityGroup?: EntityGroup;
	entity?: Entity;
}

interface getAppPermissionLevelProps {
	appPermissionConfig: PermissionLevel | AppActions;
	entityGroup?: EntityGroup;
	entity?: Entity;
}

interface getEntityGroupPermissionLevelProps {
	entityGroupPermissionConfig: PermissionLevel | EntityGroupActions;
	entity?: Entity;
}

export const getSettingsPermissionLevel = ({
	settingsPermissionConfig,
	entity
}: getSettingsPermissionLevelProps): PermissionLevel => {
	if (_isNil(settingsPermissionConfig)) {
		return undefined;
	}
	if (_includes(PERMISSION_LEVEL, settingsPermissionConfig as PermissionLevel)) {
		return settingsPermissionConfig as PermissionLevel;
	}
	if (_isNil(entity)) {
		return _reduce(
			_values(settingsPermissionConfig),
			(agg, permission) => {
				if (_isNil(permission)) {
					return agg;
				}
				return permission;
			},
			undefined
		);
	}
	return (settingsPermissionConfig as EntityGroupActions)[entity];
};

export const getMiscellaneousPermissionLevel = ({
	miscellaneousPermissionConfig,
	entity
}: getMiscellaneousPermissionLevelProps): MiscellaneousPermissionLevel => {
	if (_isNil(miscellaneousPermissionConfig)) {
		return undefined;
	}
	if (_includes(MISCELLANEOUS_PERMISSION_LEVEL, miscellaneousPermissionConfig as MiscellaneousPermissionLevel)) {
		return miscellaneousPermissionConfig as MiscellaneousPermissionLevel;
	}
	if (_isNil(entity)) {
		return _reduce(
			_values(miscellaneousPermissionConfig),
			(agg, permission) => {
				if (_isNil(permission)) {
					return agg;
				}
				return permission;
			},
			undefined
		);
	}
	return (miscellaneousPermissionConfig as MiscellaneousEntityGroupActions)[entity];
};

const getEntityGroupPermissionLevel = ({
	entityGroupPermissionConfig,
	entity
}: getEntityGroupPermissionLevelProps): PermissionLevel => {
	if (_isNil(entityGroupPermissionConfig)) {
		return undefined;
	}
	if (_includes(PERMISSION_LEVEL, entityGroupPermissionConfig as PermissionLevel)) {
		return entityGroupPermissionConfig as PermissionLevel;
	}
	if (_isNil(entity)) {
		return _reduce(
			_values(entityGroupPermissionConfig),
			(agg, permission) => {
				if (_isNil(permission)) {
					return agg;
				}
				return permission;
			},
			undefined
		);
	}
	return (entityGroupPermissionConfig as EntityGroupActions)[entity];
};

const getAppPermissionLevel = ({ appPermissionConfig, entityGroup, entity }: getAppPermissionLevelProps): PermissionLevel => {
	if (_isNil(appPermissionConfig)) {
		return undefined;
	}
	if (_includes(PERMISSION_LEVEL, appPermissionConfig as PermissionLevel)) {
		return appPermissionConfig as PermissionLevel;
	}
	if (_isNil(entityGroup)) {
		return _reduce(
			_values(appPermissionConfig),
			(agg: PermissionLevel, entityGroupPermissionConfig) => {
				const permission = getEntityGroupPermissionLevel({ entityGroupPermissionConfig, entity });
				if (_isNil(permission)) {
					return agg;
				}
				return permission;
			},
			undefined
		);
	}
	return getEntityGroupPermissionLevel({ entityGroupPermissionConfig: (appPermissionConfig as AppActions)[entityGroup], entity });
};

export const getCrmPermissionLevel = ({
	crmPermissionConfig,
	appName,
	entityGroup,
	entity
}: getCrmPermissionLevelProps): PermissionLevel => {
	if (_isNil(crmPermissionConfig)) {
		return undefined;
	}
	if (_includes(PERMISSION_LEVEL, crmPermissionConfig as PermissionLevel)) {
		return crmPermissionConfig as PermissionLevel;
	}
	if (_isNil(appName)) {
		return _reduce(
			_values(crmPermissionConfig),
			(agg: PermissionLevel, appPermissionConfig) => {
				const permission = getAppPermissionLevel({ appPermissionConfig, entityGroup, entity });
				if (_isNil(permission)) {
					return agg;
				}
				return permission;
			},
			undefined
		);
	}
	return getAppPermissionLevel({ appPermissionConfig: (crmPermissionConfig as CRMActions)[appName], entityGroup, entity });
};
